import { render } from "./Assets.vue?vue&type=template&id=01edbe9b&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=01edbe9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01edbe9b"

export default script